import { useMemo } from 'react';
import { useFragment } from '@apollo/client';
import type { AccountLockFragment } from '@frameio/graphql-client/generated';
import { AccountLock } from '@frameio/graphql-client/generated';
import { useActiveAccountId } from '@frameio/shared/contexts';

type currentAccountLockTracking = {
  account_locked: boolean;
};

export function useCurrentAccountLockTracking():
  | currentAccountLockTracking
  | undefined {
  const accountId = useActiveAccountId() ?? '';

  const { complete, data } = useFragment<AccountLockFragment>({
    fragment: AccountLock,
    fragmentName: 'AccountLock',
    from: {
      __typename: 'Account',
      id: accountId,
    },
  });

  const currentSubscriptionAddOnsTracking = useMemo(() => {
    const isAccountLocked = !!data?.lockedAt;

    if (!complete || !isAccountLocked) {
      return { account_locked: false };
    }

    return {
      account_locked: isAccountLocked,
    };
  }, [complete, data]);

  return currentSubscriptionAddOnsTracking;
}
